import * as React from 'react';

import { CitationModule } from '@coursera-web/cds-labs';

import { useGenerateStartFreeTrialTestEpicImpression } from 'bundles/coursera-plus/components/elevateLTV/startFreeTrial/useGenerateStartFreeTrialTestEpicImpression';
import ConsumerPathwayRolePageSEO from 'bundles/unified-career-academy/components/ConsumerPathwayRolePageSEO';
import { usePageData } from 'bundles/unified-career-academy/contexts/ConsumerPathwayRolePageDataContext';
import useLogRecentlyViewed from 'bundles/unified-career-academy/hooks/useLogRecentlyViewed';
import ArticlesCollectionModuleRenderer from 'bundles/unified-career-academy/module-renderers/ArticlesCollectionModuleRenderer';
import OnboardingModuleRenderer from 'bundles/unified-career-academy/module-renderers/OnboardingModuleRenderer';
import RelatedRolesModuleRenderer from 'bundles/unified-career-academy/module-renderers/RelatedRolesModuleRenderer';
import TestimonialsModuleRenderer from 'bundles/unified-career-academy/module-renderers/TestimonialsModuleRenderer';
import HeroModuleRenderer from 'bundles/unified-career-academy/module-renderers/hero-module/RolePageHeroModuleRenderer';
import PathwaysModuleRenderer from 'bundles/unified-career-academy/module-renderers/pathways-module/PathwaysModuleRenderer';
import { getPathwayDisclaimer } from 'bundles/unified-common/utils/getPathwaysDisclaimers';

export const ConsumerPathwayRolePageRootContent = () => {
  const pageData = usePageData();

  useLogRecentlyViewed({
    name: pageData?.careerRoleData?.name,
    slug: pageData?.careerRoleData?.slug,
    id: pageData?.careerRoleData?.id,
  });

  useGenerateStartFreeTrialTestEpicImpression({});

  if (pageData?.loading) {
    // TODO: Add loading state
    // https://coursera.atlassian.net/browse/MERCH-681
    return null;
  }

  return (
    <div>
      <HeroModuleRenderer pageData={pageData} />
      <PathwaysModuleRenderer pageData={pageData} />
      <OnboardingModuleRenderer />
      <ArticlesCollectionModuleRenderer pageData={pageData} />
      <TestimonialsModuleRenderer pageData={pageData} />
      <RelatedRolesModuleRenderer pageData={pageData} />
      <CitationModule citations={getPathwayDisclaimer()} />
      <ConsumerPathwayRolePageSEO pageData={pageData} />
    </div>
  );
};

export default ConsumerPathwayRolePageRootContent;
